export default __webpack_public_path__ + "static/media/user-mike.f4491f75.png";